import { render, staticRenderFns } from "./dialog-btn-vertical.mpx?vue&type=template&id=06089d9d&isComponent&outputPath=components%2Fdialog-btn-vertical55c7fc88%2Findex"
import script from "./dialog-btn-vertical.mpx?vue&type=script&lang=js&isComponent&outputPath=components%2Fdialog-btn-vertical55c7fc88%2Findex"
export * from "./dialog-btn-vertical.mpx?vue&type=script&lang=js&isComponent&outputPath=components%2Fdialog-btn-vertical55c7fc88%2Findex"
import style0 from "./dialog-btn-vertical.mpx?vue&type=style&index=0&id=06089d9d&prod&lang=stylus&mpxStyleOptions=%7B%22mid%22%3A%22_55c7fc88%22%7D&isComponent&outputPath=components%2Fdialog-btn-vertical55c7fc88%2Findex"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports